export const typeData = ['LEO', 'SM_ORDER', 'OTHER'];

export const typeAccessor: Record<string, string> = {
  LEO: 'Leolvasás',
  SM_ORDER: 'Ügyfélcsere',
  OTHER: 'Egyéb',
};
